import {Component, Input} from '@angular/core';
import {Thuisverzorger} from '../../thuisverzorger/thuisverzorger';
import {Prestatie} from '../prestatie';
import {Client} from '../../client/client';

@Component({
    selector: 'zah-prestatie-header',
    templateUrl: './prestatie-header.component.html',
    styleUrls: ['./prestatie-header.component.scss'],
    standalone: false
})
export class PrestatieHeaderComponent {

  @Input()
  prestatie: Prestatie;
  @Input()
  client: Client;
  @Input()
  thuisverzorger: Thuisverzorger;

}
